import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { createCompany } from '../api/company'
import './CompanyRegistration.css'
import { NoticeModal } from '../components/Modals';

const CompanyRegistration = () => {
  const [companyName, setCompanyName] = useState('')
  const [error, setError] = useState(null)
  const navigate = useNavigate()
  const [noticeOpen, setNoticeOpen] = useState(false);
  const [noticeMsg, setNoticeMsg] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError(null)

    try {
      const response = await createCompany(companyName)
      console.log('response:', response)

      const companyId = response.company?.id
      if (!companyId) {
        setError('会社IDが返ってきませんでした。管理者にお問い合わせください。')
        return
      }

      setNoticeMsg('企業登録が完了しました');
      setNoticeOpen(true);
      
      navigate('/implpage')

    } catch (err) {
      console.error(err)

      if (err.response && err.response.status === 422 && err.response.data.errors) {
        const validationErrors = err.response.data.errors
        const messages = Object.values(validationErrors).flat().join('\n')
        setError(messages)
      } else {
        setError('登録に失敗しました。時間をおいて再度お試しください。')
      }
    }
  }

  return (
    <div className="registBody">
      <h2 className='companyRegistrationTitle'>企業登録</h2>
      <div className='inputCompany'>
        <label>企業名
        <input
          type="text"
          placeholder="企業名を入力してください"
          className='campaignRegistrationInput'
          value={companyName}
          onChange={e => setCompanyName(e.target.value)}
          required
        />
        </label>
      <div className='registButtons'>
        {error && <p style={{ color: 'red', whiteSpace: 'pre-wrap' }}>{error}</p>}
        <button 
          type="submit"
          className="registButton"
          onClick={handleSubmit}
        >
        登録する
        </button>

        <button
          type="button"
          className='registbackButton'
          onClick={() => navigate('/implpage')}
        >
        企業ポータルに戻る
        </button>
      </div>
      </div>
      <NoticeModal
        open={noticeOpen}
        onClose={() => setNoticeOpen(false)}
        message={noticeMsg}
      />
    </div>
  )
}

export default CompanyRegistration